import {UI} from "../../../stem-core/ui/UIBase";
import {styleRule, StyleSheet} from "../../../stem-core/ui/Style";
import {MerchantTableList} from "./MerchantTableList.jsx";
import {Merchant} from "../../../client/state/MerchantStore.js";
import {AdminMerchant} from "../../../client/state/merchant/AdminMerchantStore";
import {CreateMerchantModal} from "./CreateMerchantModal.jsx";
import {CreateLegalEntityModal} from "./legal-entities/CreateLegalEntityModal.jsx";
import {autoredraw} from "../../../stem-core/decorators/AutoRedraw";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {Button} from "../../../stem-core/ui/button/Button.jsx";
import {TopLevelTabArea} from "../../../dashboard/common/theme/TabAreaStyle";
import {LegalEntity} from "../../../client/state/LegalEntityStore.js";
import {DashboardTitle} from "../../../dashboard/common/DashboardTitle.js";
import {SimpleTable} from "../../../dashboard/ui/SimpleTable.jsx";
import {CENTER_COLUMN, DATE_COLUMN, LEFT_COLUMN} from "../../../dashboard/common/theme/TableStyle";


class MerchantListStyle extends StyleSheet {
    @styleRule
    actionButtonsContainer = {
        display: "flex",
        flexDirection: "row",
        margin: "10px 0px 10px 0px",

        "> :not(:last-child)": {
           marginRight: 10,
        }
    };
}

@autoredraw(Merchant)
@registerStyle(MerchantListStyle)
export class MerchantList extends UI.Element {
    render() {
        // AdminMerchant shares Merchant's object map and is the class the admin registers for merchants
        // (GlobalState.stores.set in AdminMerchantStore), so this is the same list, typed as what it holds
        const merchants = AdminMerchant.all();
        return [
            <div className={this.styleSheet.actionButtonsContainer}>
                <Button onClick={() => CreateMerchantModal.show()}>Create Merchant</Button>
            </div>,
            <MerchantTableList entries={merchants}/>,
        ];
    }
}


@autoredraw(LegalEntity)
@registerStyle(MerchantListStyle)
class LegalEntityList extends UI.Element {
    render() {
        const columns = [
            ["Id", (entity: LegalEntity) => entity.id, LEFT_COLUMN],
            ["Name", (entity: LegalEntity) => entity.name, LEFT_COLUMN],
            ["Legal name", (entity: LegalEntity) => entity.legalName, LEFT_COLUMN],
            ["Created At", (entity: LegalEntity) => entity.createdAt, DATE_COLUMN],
            ["Card statement name", (entity: LegalEntity) => entity.cardStatementName, CENTER_COLUMN],
            ["Owner Id", (entity: LegalEntity) => entity.ownerId, CENTER_COLUMN], // TODO: get the email here
        ];

        const entries = LegalEntity.all();

        return [
            <div className={this.styleSheet.actionButtonsContainer}>
                <Button onClick={() => CreateLegalEntityModal.show()}>Create Legal Entity</Button>
            </div>,
            <SimpleTable columns={columns} entries={entries} />,
        ]
    }
}

export class AdminMerchantsPage extends UI.Element {
    render() {
        return [
            <DashboardTitle title={"Manage merchants and legal entities"} />,
            <TopLevelTabArea>
                <MerchantList title="Merchants" />
                <LegalEntityList title="Legal Entities" />
            </TopLevelTabArea>
        ]
    }
}
